import React from "react";

import { FilterResourcePlanOverview } from "@src/features/resource_plan_overview/components/filter_resource_plan_overview/index";
import { FilterButton } from "@src/features/table_filtering/components/filter_button";
import { FiltersDrawer } from "@src/features/table_filtering/components/filters_drawer/index";
import { SearchInput } from "@src/features/table_filtering/components/search_input";
import { setResourcePlanOverviewQuickFilter } from "@src/services/resourcePlanOverviewSlice";
import { useAppDispatch, useAppSelector, RootState } from "@src/setupStore";
import { ResourcePlanOverviewTableRowData } from "@src/types/resource_plan_types";

interface ResourcePlanOverviewToolBarProps {
  isFetching: boolean;
  isDisabled: boolean;
  resourcePlans: ResourcePlanOverviewTableRowData[];
}

const ResourcePlanOverviewToolBar: React.FC<
  ResourcePlanOverviewToolBarProps
> = ({ isFetching, isDisabled, resourcePlans }) => {
  const dispatch = useAppDispatch();

  const [openFilterDrawer, setOpenFilterDrawer] =
    React.useState<boolean>(false);

  const isTableLoading: boolean = isFetching || isDisabled;

  const { quickFilter } = useAppSelector(
    (state: RootState) => state.resourcePlanOverviewSlice
  );

  function renderFilters(): React.ReactNode {
    return (
      <FilterResourcePlanOverview
        disabled={isFetching}
        resourcePlans={resourcePlans}
      />
    );
  }

  return (
    <div className="tool-bar">
      <div className="tool-bar__button-section">
        <SearchInput
          disabled={isTableLoading}
          defaultValue={quickFilter}
          onChange={(value: string) =>
            dispatch(setResourcePlanOverviewQuickFilter(value))
          }
        />
      </div>
      <div className="tool-bar__button-section">
        <div>
          <FilterButton
            setOpenFilterDrawer={() => setOpenFilterDrawer(true)}
            disabled={isTableLoading}
          />
        </div>
      </div>
      <FiltersDrawer
        isDrawerOpen={openFilterDrawer}
        setIsDrawerOpen={setOpenFilterDrawer}
        drawerTitle="Filter resource plans"
        filters={renderFilters()}
      />
    </div>
  );
};

export default ResourcePlanOverviewToolBar;
